import Banner from './banner/index.vue';
import Finance from './finance/index.vue';
import Recommend from './recommend/index.vue';
import List from './list/index.vue';
import Query from './query/index.vue';
import Trade from './trade/index.vue';
import News from './news/index.vue';
import MapHotspot from './map-hotspot/index.vue';
import ProductList from './product-list/index.vue';
import IndustrialLayout from './industrial-layout/index.vue';
import { mapMutations, mapGetters } from 'vuex';
import Service from '@/service/index.js';
import { isProvincialSites } from '@/utils/common.js';
import { getQRCode } from '@/utils/common.js';
import SwiperBanner from '@/components/slider-banner/index.vue';
import NewsService from '@/views/finance-insurance/service';
import DemandList from './demand-list/index.vue';
import LinkService from './service';
export default {
  components: {
    SwiperBanner,
    Banner,
    Finance,
    Recommend,
    List,
    Query,
    Trade,
    News,
    IndustrialLayout,
    MapHotspot,
    ProductList,
    DemandList
  },
  data() {
    return {
      showDialog: false,
      isShowMap: true,
      isShowNotice: true,
      count: 0,
      trading: [
        { name: '项目详情', img: require('@/assets/images/home/jylc/项目申请.png') },
        { name: '项目审核', img: require('@/assets/images/home/jylc/项目审核.png') },
        { name: '项目挂牌', img: require('@/assets/images/home/jylc/项目挂牌.png') },
        { name: '报名登记', img: require('@/assets/images/home/jylc/报名登记.png') },
        { name: '组织竞价', img: require('@/assets/images/home/jylc/组织竞价.png') },
        { name: '成交确认', img: require('@/assets/images/home/jylc/成交确认.png') },
        { name: '合同签订', img: require('@/assets/images/home/jylc/合同签订.png') },
        { name: '资金结算', img: require('@/assets/images/home/jylc/资金结算.png') },
        { name: '交易鉴证', img: require('@/assets/images/home/jylc/交易鉴证.png') }
      ],
      newsList: [],
      linkList: []
    };
  },
  computed: {
    ...mapGetters([
      'assetsBidInfos'
    ])
  },
  created() {
    // 子网站才展示
    this.isShowNotice = !isProvincialSites();

    Service.getSelectList('PROJECT_TYPE').then(res => {
      if (res && res.code === '0') {
        this.GET_PROJECT_TYPE(res.data);
      }
    });
    this.getActiveIndexLevel();
    this.getNewsList();
    LinkService.getLinkManagementList({ limit: 30, status: 'enabled', tId: '66aaf74f247b9fffdb5eba08'}).then(res => {
      this.linkList = res.result;
    }, error => {
      this.$errorMessage(error && error.reason);
    });
  },
  mounted() {
    if (this.count === 0 && document.documentElement.scrollTop) {
      document.documentElement.scrollTop = 0;
      this.count++;
    }
  },
  methods: {
    ...mapMutations([
      'GET_PROJECT_TYPE'
    ]),
    getQRCode,
    toDetailPage(type) {
      this.$router.push({ path: '/about-us/market-member-detail', query: { id: type } });
    },

    toTargetPage(item) {
      if (item.url && item.url.indexOf('http') >= 0) {
        window.open(item.url);
      } else {
        this.$router.push({ path: item.url });
      }
    },

    toNewsList() {
      this.$router.push({ path: '/finance-insurance/InformationList?id=4'});
    },

    toNewsDetail(index) {
      this.$router.push('/finance-insurance/InformationDetails?id=' + this.newsList[index].id);
    },
    getNewsList() {
      NewsService.getnews({ catalogId: '67da271b3e7d4606761cc285', limit: 9 }).then(res => {
        this.newsList = res.result.map(item => {
          return {
            ...item.coverImg && item.coverImg[0],
            id: item._id
          };
        });
      });
    },
    toProductList() {
      this.$router.push({ path: '/socialized-service/e-commerce/list' });
    },
    goNewsList() {
      this.$router.push('/news/news-list/1');
    },
    goTrans() {
      this.$router.push('/transaction-pro/list');
    },
    // 竞价大厅查看更多
    goBidDetail() {
      this.$router.push('/bid-project');
    },

    getActiveIndexLevel() {
      let origin = window.location.href;
      let domainName;
      if (origin.split('//')[1].split('.')[0] === 'www') {
        domainName = origin.split('//')[1].split('.')[1];
      } else {
        domainName = origin.split('//')[1].split('.')[0];
        if (domainName.includes('localhost')) {
          domainName = 'localhost';
        }
      }
      Service.selectSiteInfoByDomain(domainName).then(res => {
        if (res.code === '0') {
          if (Number(res.data.level) === 4) {
            this.isShowMap = false;
          } else {
            this.isShowMap = true;
          }
          // this.isShowMap = (Number(res.level) !== 4 || domain.indexOf('localhost') >= 0);
        }
      });
    }
  }
};
